import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EBillingCopayType } from './billing-copay';
import { ETransactionVendor } from './billing-transaction';
import { EModel } from './model';
/**
 * Enum representing the actions associated with payment auditing.
 */
export let EPaymentAuditAction;

/**
 * Interface representing a payment audit record.
 */
(function (EPaymentAuditAction) {
  EPaymentAuditAction["PaymentManuallyRequested"] = "payment-manually-requested";
  EPaymentAuditAction["TransactionStarted"] = "transaction-started";
  EPaymentAuditAction["TransactionSucceeded"] = "transaction-succeeded";
  EPaymentAuditAction["TransactionFailed"] = "transaction-failed";
  EPaymentAuditAction["TransactionNotPaid"] = "transaction-not-paid";
  EPaymentAuditAction["TransactionIncomplete"] = "transaction-incomplete";
  EPaymentAuditAction["TransactionProcessing"] = "transaction-processing";
  EPaymentAuditAction["TransactionDeclined"] = "transaction-declined";
  EPaymentAuditAction["PaymentPostedToEHR"] = "payment-posted-to-ehr";
  EPaymentAuditAction["BalanceSyncedFromEHR"] = "balance-synced-from-ehr";
  EPaymentAuditAction["CopaySyncedFromEHR"] = "copay-synced-from-ehr";
  EPaymentAuditAction["TransactionPartiallyRefunded"] = "transaction-partially-refunded";
  EPaymentAuditAction["TransactionRefunded"] = "transaction-refunded";
})(EPaymentAuditAction || (EPaymentAuditAction = {}));
export const fieldsPaymentAudit = _extends({}, fieldsIBaseModel, {
  action: {
    type: 'Option',
    values: EPaymentAuditAction
  },
  amount: {
    type: 'Number'
  },
  amountType: {
    type: 'Option',
    values: EBillingCopayType
  },
  appointment: {
    type: 'Object'
  },
  balance: {
    type: 'Number'
  },
  balanceUpdatedAt: {
    type: 'Date'
  },
  billingCopay: {
    type: 'Object'
  },
  billingTransaction: {
    type: 'Object'
  },
  createdBy: {
    type: 'Object'
  },
  error: {
    type: 'Unknown'
  },
  log: {
    type: 'Text'
  },
  patient: {
    type: 'Object'
  },
  service: {
    type: 'Text'
  },
  success: {
    type: 'Boolean'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  vendor: {
    type: 'Option',
    values: ETransactionVendor
  }
});